import { ChartPieIcon, CommandLineIcon, HomeIcon, RocketLaunchIcon } from "@heroicons/react/24/outline";
import { BuildURLs, RootURLS } from "constants/in-app-urls";

export const PRIMARY_MENUS = [
    // { label: "Home", type: "HOME", href: `/${RootURLS.ANALYZE_URL}/`, icon: HomeIcon, current: true },
    {
        label: "Build",
        type: "BUILD",
        entitlementFeatureName: "build",
        href: BuildURLs.GET_STARTED_URL,
        secondaryHref: null,
        icon: CommandLineIcon,
        current: true
    },
    {
        label: "Analyze",
        type: "ANALYZE",
        entitlementFeatureName: "analyze",
        href: `/${RootURLS.ANALYZE_URL}/`,
        icon: ChartPieIcon,
        current: false
    },
    {
        label: "CRM",
        type: "DRIVE",
        entitlementFeatureName: "customer-analytics-crm",
        href: `/${RootURLS.DRIVE_URL}`,
        icon: RocketLaunchIcon,
        current: false
    }
];
